/* eslint-disable */
import api from '@/services/api';

export const URL = '/cadastro/unidade-medida';

export default {
  async fetchListaUnidadesMedida(context, payload) {
    const keys = Object.keys(payload);
    const params = new URLSearchParams();
    /* eslint-disable */
    for (const key of keys) {
      if (payload[key]) {
        params.append(key, payload[key]);
      }
    }

    context.dispatch('toggleLoading', true, { root: true });
    const response = await api.get(`${URL}`, { params });
    context.commit('SET_LISTA_UNIDADE_MEDIDA', response.data.data);
    context.commit('paginacao/SET_PAGINADOR', response.data, { root: true });
    context.dispatch('toggleLoading', false, { root: true });
  },

  async filtrar({ commit }, payload) {
    commit('SET_FILTROS', payload);
  },

  salvarUnidadeMedida({ dispatch }, payload) {
    if (payload.id) {
      return api.put(`${URL}/${payload.id}`, {
        ...payload
      });
    }
    api.post(URL, {
      ...payload,
    });
  },

  deletarUnidadeMedida({ dispatch }, payload) {
    return api.delete(`${URL}/${payload}`);
  },

  async fetchUnidadesMedida(context) {
    const response = await api.get(`${URL}/all`);
    context.commit('SET_UNIDADES_MEDIDA', response.data);
  }
};
